import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'whytelus',
  footer: 'about',
}

const pageBrand: PageBrand = 'corporate'

export const whyTelus = new LineOfBusinessConfig(geConfig, pageBrand)
